import { render } from "./group_order.vue?vue&type=template&id=0143b4e9"
import script from "./group_order.vue?vue&type=script&lang=js"
export * from "./group_order.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__